import type { VehicleHistoryEventType } from "@slfinrtl/ui-bff-routes"
import { defineMessages } from "react-intl"

export const eventTypeMessages = defineMessages<VehicleHistoryEventType>({
	ConfiguratorImagesChanged: {
		defaultMessage: "Configurator images updated",
		id: "vehicleHistory.eventType.configuratorImagesChanged",
	},
	Image360UrlChanged: {
		defaultMessage: "360° image updated",
		id: "vehicleHistory.eventType.image360UrlChanged",
	},
	RealImagesChanged: {
		defaultMessage: "Real images updated",
		id: "vehicleHistory.eventType.realImagesChanged",
	},
	VehicleAddedToInventory: {
		defaultMessage: "Vehicle added to inventory",
		id: "vehicleHistory.eventType.vehicleAddedToInventory",
	},
	VehicleArrivedAtDealership: {
		defaultMessage: "Vehicle arrived at dealership",
		id: "vehicleHistory.eventType.vehicleArrivedAtDealership",
	},
	VehicleChanged: {
		defaultMessage: "Vehicle data updated",
		id: "vehicleHistory.eventType.vehicleChanged",
	},
	VehicleConfigurationFixed: {
		defaultMessage: "Vehicle configuration fixed",
		id: "vehicleHistory.eventType.vehicleConfigurationFixed",
	},
	VehicleDealershipChanged: {
		defaultMessage: "Dealer assignment updated",
		id: "vehicleHistory.eventType.vehicleDealershipChanged",
	},
	VehicleDelivered: {
		defaultMessage: "Vehicle delivered",
		id: "vehicleHistory.eventType.vehicleDelivered",
	},
	VehicleDeliveryRevoked: {
		defaultMessage: "Delivery revoked",
		id: "vehicleHistory.eventType.vehicleDeliveryRevoked",
	},
	VehicleOrderChanged: {
		defaultMessage: "OneVMS Order Data Updated",
		id: "vehicleHistory.eventType.vehicleOrderChanged",
	},
	VehiclePricingChanged: {
		defaultMessage: "Price updated",
		id: "vehicleHistory.eventType.vehiclePricingChanged",
	},
	VehicleProduced: {
		defaultMessage: "Vehicle produced",
		id: "vehicleHistory.eventType.vehicleProduced",
	},
	VehiclePvmsOrderChanged: {
		defaultMessage: "PVMS Order data updated",
		id: "vehicleHistory.eventType.vehiclePvmsOrderChanged",
	},
	VehicleRemoved: {
		defaultMessage: "Vehicle removed from inventory",
		id: "vehicleHistory.eventType.vehicleRemoved",
	},
	VehicleReservationCancelled: {
		defaultMessage: "Reservation cancelled",
		id: "vehicleHistory.eventType.vehicleReservationCancelled",
	},
	VehicleReservationChanged: {
		defaultMessage: "Reservation updated",
		id: "vehicleHistory.eventType.vehicleReservationChanged",
	},
	VehicleReserved: {
		defaultMessage: "Vehicle reserved",
		id: "vehicleHistory.eventType.vehicleReserved",
	},
	VehicleSaleCancelled: {
		defaultMessage: "Sale cancelled",
		id: "vehicleHistory.eventType.vehicleSaleCancelled",
	},
	VehicleSaleChanged: {
		defaultMessage: "Sale updated",
		id: "vehicleHistory.eventType.vehicleSaleChanged",
	},
	VehicleSold: {
		defaultMessage: "Vehicle sold",
		id: "vehicleHistory.eventType.vehicleSold",
	},
	VehicleTransferred: {
		defaultMessage: "Vehicle transferred",
		id: "vehicleHistory.eventType.vehicleTransferred",
	},
	VehicleUsageCancelled: {
		defaultMessage: "Usage cancelled",
		id: "vehicleHistory.eventType.vehicleUsageCancelled",
	},
	VehicleUsageEnded: {
		defaultMessage: "Usage ended",
		id: "vehicleHistory.eventType.vehicleUsageEnded",
	},
	VehicleUsageStarted: {
		defaultMessage: "Usage started",
		id: "vehicleHistory.eventType.vehicleUsageStarted",
	},
	VehicleVinAdded: {
		defaultMessage: "VIN added",
		id: "vehicleHistory.eventType.vehicleVinAdded",
	},
	VideoChanged: {
		defaultMessage: "Video updated",
		id: "vehicleHistory.eventType.videoChanged",
	},
})
